import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import store from './store'
import router from './router'
import 'ant-design-vue/dist/antd.css'
import './app.less'
import config from './config'

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use({
  install(vue) {
    vue.prototype.$config = config
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')